var _circle, _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModifyAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.41418,
    y: 14,
    width: 9,
    height: 2,
    rx: 1,
    transform: "rotate(45 9.41418 14)",
    fill: "#00893F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.61096,
    y: 20.4749,
    width: 9,
    height: 2,
    rx: 1,
    transform: "rotate(-45 7.61096 20.4749)",
    fill: "#00893F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 17.1516L26.1457 12.3518C25.7557 12.0086 25.1694 11.9054 24.6594 12.0914C24.1507 12.2774 23.818 12.7154 23.818 13.2002V16.8H18.3636C17.6109 16.8 17 17.3376 17 18C17 18.6624 17.6109 19.2 18.3636 19.2H23.818V22.7998C23.818 23.2846 24.1507 23.7226 24.6594 23.9086C25.1694 24.0946 25.7557 23.9914 26.1457 23.6482L31.6001 18.8484C32.1333 18.3792 32.1333 17.6208 31.6001 17.1516Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyAccess);
export default __webpack_public_path__ + "static/media/modify-access.e5ed51cd.svg";
export { ForwardRef as ReactComponent };